import axios from 'axios'

import { resolveRequest, TAsyncRequestResult } from 'utility-tools/module/requests'

const requestIpAddress = async (): TAsyncRequestResult<{ ip: string }> =>
    resolveRequest<{ ip: string }>(
        axios.get('/api/detect-ip', {
            headers: {
                'Content-Type': 'application/json',
            },
            timeout: 10000,
        }),
    )

export { requestIpAddress }
